import { IUser, User, EUserRole, EpediatricVaccinations } from '../';
import { EPediatricVaccinationType } from '../../pediatric-vaccination.entity/pediatric-vaccination';
import Speciality from './speciality.entity';
import { DoctorSubSpeciality } from './sub-speciality.entity';
export enum AppointmentTiming {
  CALANDER,
  DATEHEURE,
  DATE,
}

export enum EDoctorProfessionalTitle {
  UNKNOWN,
  MS_MM,
  DOCTOR,
  PROFESSOR,
}
interface IDoctor extends IUser {
  //educations: { title: string; description: string; startYear: number; endYear?: number | undefined; }[];
  //experiences: { title: string; description: string; startYear: number; endYear?: number | undefined; }[];
  //awards: { date: number; title: string; description: string; }[];
  //services: string[];
  //businessHours: Map<Day, { start: Time; end: Time; }[]>;
  //locations: IDoctorLocalization[];
  //reviews: IDoctorReview[];
  fixPhone: string;
  psychomotorAssessment: boolean;
  arabicFirstName: string;
  arabicLastName: string;
  arabicAddress: string;
  professionalCivility: string;
  arabicProfessionalCivility: string;
  professionalTitle: EDoctorProfessionalTitle;
  speciality: Speciality;
  specialityDoctorName: string;
  specialityDoctorArabicName: string;
  subSpecialities: Array<DoctorSubSpeciality>;
  timeSlotLocalSetting: number;
  biography: string;
  arabicBiography: string;
  consultationActs: boolean;
  consultationVaccinations: boolean;
  consultationBiology: boolean;
  consultationRadiology: boolean;
  consultationRefraction: boolean;
  consultationLaser: boolean;
  consultationLens: boolean;
  appointmentTiming: AppointmentTiming;
  prescriptionActs: boolean;
  prescriptionBiology: boolean;
  prescriptionRadiology: boolean;
  prescriptionRefraction: boolean;
  prescriptionLaser: boolean;
  prescriptionLens: boolean;
  hasCalender: boolean;
  hasCalenderUpToDate: boolean;
  cnam: string;
  enableDocuments: boolean;
  printSpeciality: string;
  printArabicSpeciality: string;
  printAddress: string;
  printArabicAddress: string;
  printFullName: string;
  printArabicFullName: string;
  dashboardPrintPayments: boolean;
  patientRefSetting: boolean;
  regularConsultationPriceSetting: number;
  secretaryPaymentsSetting: boolean;
  secretaryAPSetting: boolean;
  consultationCNAMAP1: boolean;
  consultationCNAMAP2: boolean;
  consultationCNAMAP3: boolean;
  consultationCNAMAP4: boolean;
  pediatricVaccinations: boolean;
  smsNotification: boolean;
  smsPhone: string;
  teleconsultationWaitTime: number;
  qualifications: Array<string>;
  arabicQualifications: Array<string>;
  spokenLanguages: Array<string>;
  consultationAmountTND: number;
  consultationAmountUSD: number;
  consultationAmountEUR: number;
  packStart: boolean;
  packPro: boolean;
  cliniqueId?: string;
  regularConsultationPriceSettingInEuro: number;
  regularConsultationPriceSettingInDollar: number;
  regularConsultationPriceSettingInCNAM: number;
  regularConsultationPriceSettingInCNAMTP: number;
  logo: string | null;
  matriculeFiscal: string;
  doctorTierPayant: boolean;
  doctorHoliday: boolean;
  secondOpinionEnabled: boolean;
  duplicateAppointment: boolean;
  displayAtcd: boolean | null;
  paymentPasswordEnabled: boolean;
  enableConsultationMotif: boolean;
  enablePaymentdate: boolean;
  speechtoText: boolean;
  rdvmultiple: boolean,
  secretaryPaymentsDashboard: boolean;
  secretaryBordereau: boolean;
  chirurgieRequest: boolean;
  enabledQuestion: boolean;
  epediatricVaccinations: EpediatricVaccinations;
  enableWaitingRoom:boolean;

}

export class Doctor extends User implements IDoctor {
  arabicFirstName: string;
  arabicLastName: string;
  arabicAddress: string;
  professionalCivility: string;
  arabicProfessionalCivility: string;
  professionalTitle: number;
  speciality: Speciality;
  specialityDoctorName: string;
  specialityDoctorArabicName: string;
  subSpecialities: Array<DoctorSubSpeciality> = [];
  fixPhone: string;
  timeSlotLocalSetting: number;
  biography: string;
  arabicBiography: string;
  matriculeFiscal: string;
  psychomotorAssessment: boolean;

  enableDocuments: boolean;
  chirurgieRequest: boolean;
  displayAtcd: boolean | null;
  cliniqueId?: string | undefined;
  //educations: { title: string; description: string; startYear: number; endYear?: number | undefined; }[];
  //experiences: { title: string; description: string; startYear: number; endYear?: number | undefined; }[];
  //awards: { date: number; title: string; description: string; }[];
  //services: string[];
  //businessHours: Map<Day, { start: Time; end: Time; }[]>;
  //locations: IDoctorLocalization[];
  //reviews: IDoctorReview[];
  password?: string | undefined;
  hasCalender: boolean;
  hasCalenderUpToDate: boolean;
  consultationActs: boolean;
  consultationVaccinations: boolean;
  consultationBiology: boolean;
  consultationRadiology: boolean;
  consultationRefraction: boolean;
  consultationLaser: boolean;
  consultationLens: boolean;
  prescriptionActs: boolean;
  prescriptionBiology: boolean;
  prescriptionRadiology: boolean;
  prescriptionRefraction: boolean;
  prescriptionLaser: boolean;
  prescriptionLens: boolean;
  cnam: string;
  printSpeciality: string;
  printArabicSpeciality: string;
  printAddress: string;
  printArabicAddress: string;
  printFullName: string;
  printArabicFullName: string;
  dashboardPrintPayments: boolean;
  patientRefSetting: boolean;
  regularConsultationPriceSetting: number;
  secretaryPaymentsSetting: boolean;
  secretaryAPSetting: boolean;
  appointmentTiming: AppointmentTiming;
  consultationCNAMAP1: boolean;
  consultationCNAMAP2: boolean;
  consultationCNAMAP3: boolean;
  consultationCNAMAP4: boolean;
  pediatricVaccinations: boolean;
  smsNotification: boolean;
  smsPhone: string;
  teleconsultationWaitTime: number;
  qualifications: Array<string> = new Array();
  arabicQualifications: Array<string> = new Array();
  spokenLanguages: Array<string> = new Array();
  consultationAmountTND: number;
  consultationAmountUSD: number;
  consultationAmountEUR: number;
  packStart: boolean;
  packPro: boolean;
  regularConsultationPriceSettingInEuro: number;
  regularConsultationPriceSettingInDollar: number;
  regularConsultationPriceSettingInCNAM: number;
  regularConsultationPriceSettingInCNAMTP: number;
  logo: string | null;
  doctorTierPayant: boolean;
  duplicateAppointment: boolean;
  doctorHoliday: boolean;
  secondOpinionEnabled: boolean;
  enableConsultationMotif: boolean;
  enablePaymentdate: boolean;
  speechtoText: boolean;
  rdvmultiple: boolean
  secretaryPaymentsDashboard: boolean;
  secretaryBordereau: boolean;
  // Indique si le médecin a activé un mot de passe de paiement (le hash n'est jamais exposé côté front)
  paymentPasswordEnabled: boolean;
  enabledQuestion: boolean;
  epediatricVaccinations: EpediatricVaccinations;
    enableWaitingRoom:boolean;

  override getFullName(inverted?: boolean | undefined): string {
    return inverted ? this.lastName + ' ' + this.firstName + '.' + this.professionalCivility : this.professionalCivility + '.' + this.firstName + ' ' + this.lastName;
  }
  getArabicFullName(inverted?: boolean): string {
    return inverted ? this.arabicLastName + ' ' + this.arabicFirstName + '.' + this.arabicProfessionalCivility : this.arabicProfessionalCivility + '.' + this.arabicFirstName + ' ' + this.arabicLastName;
  }

  constructor(other?: Partial<IDoctor>) {
    super(other as User);
    this.arabicFirstName = other?.arabicFirstName || '';
    this.arabicLastName = other?.arabicLastName || '';
    this.professionalCivility = other?.professionalCivility || '';
    this.arabicProfessionalCivility = other?.arabicProfessionalCivility || '';
    this.professionalTitle = other?.professionalTitle || 0;
    this.speciality = other?.speciality || new Speciality();
    this.specialityDoctorName = other?.specialityDoctorName || '';
    this.specialityDoctorArabicName = other?.specialityDoctorArabicName || '';
    this.subSpecialities = other?.subSpecialities || [];
    this.fixPhone = other?.fixPhone || '';
    this.biography = other?.biography || '';
    this.arabicBiography = other?.arabicBiography || '';
    this.timeSlotLocalSetting = other?.timeSlotLocalSetting || 0;
    this.consultationBiology = other?.consultationBiology || false;
    this.consultationActs = other?.consultationActs || false;
    this.consultationLaser = other?.consultationLaser || false;
    this.consultationRadiology = other?.consultationRadiology || false;
    this.consultationRefraction = other?.consultationRefraction || false;
    this.consultationVaccinations = other?.consultationVaccinations || false;
    this.consultationLens = other?.consultationLens || false;
    this.prescriptionActs = other?.prescriptionActs || false;
    this.prescriptionBiology = other?.prescriptionBiology || false;
    this.prescriptionLaser = other?.prescriptionLaser || false;
    this.prescriptionRadiology = other?.prescriptionRadiology || false;
    this.prescriptionRefraction = other?.prescriptionRefraction || false;
    this.prescriptionLens = other?.prescriptionLens || false;
    this.hasCalender = other?.hasCalender || false;
    this.hasCalenderUpToDate = other?.hasCalenderUpToDate || false;
    this.arabicAddress = other?.arabicAddress || '';
    this.cnam = other?.cnam || '';
    this.printSpeciality = other?.printSpeciality || '';
    this.printArabicSpeciality = other?.printArabicSpeciality || '';
    this.printAddress = other?.printAddress || '';
    this.printArabicAddress = other?.printArabicAddress || '';
    this.printFullName = other?.printFullName || '';
    this.printArabicFullName = other?.printArabicFullName || '';
    this.dashboardPrintPayments = other?.dashboardPrintPayments || false;
    this.patientRefSetting = other?.patientRefSetting || false;
    this.regularConsultationPriceSetting = other?.regularConsultationPriceSetting || 0;
    this.secretaryPaymentsSetting = other?.secretaryPaymentsSetting || false;
    this.secretaryAPSetting = other?.secretaryAPSetting || false;
    this.consultationCNAMAP1 = other?.consultationCNAMAP1 || false;
    this.consultationCNAMAP2 = other?.consultationCNAMAP2 || false;
    this.consultationCNAMAP3 = other?.consultationCNAMAP3 || false;
    this.consultationCNAMAP4 = other?.consultationCNAMAP4 || false;
    this.role = EUserRole.DOCTOR;
    this.appointmentTiming = other?.appointmentTiming || AppointmentTiming.CALANDER;
    this.pediatricVaccinations = other?.pediatricVaccinations || false;
    this.smsNotification = other?.smsNotification || false;
    this.smsPhone = other?.smsPhone || '';
    this.teleconsultationWaitTime = other?.teleconsultationWaitTime || 0;
    this.qualifications = other?.qualifications || [];
    this.arabicQualifications = other?.arabicQualifications || [];
    this.spokenLanguages = other?.spokenLanguages || [];
    this.consultationAmountTND = other?.consultationAmountTND || 0;
    this.consultationAmountUSD = other?.consultationAmountUSD || 0;
    this.consultationAmountEUR = other?.consultationAmountEUR || 0;
    this.packPro = other?.packPro || false;
    this.packStart = other?.packStart || true;
    this.logo = other?.logo || null;
    this.matriculeFiscal = other?.matriculeFiscal || '';
    this.regularConsultationPriceSettingInEuro = other?.regularConsultationPriceSettingInEuro || 0;
    this.regularConsultationPriceSettingInDollar = other?.regularConsultationPriceSettingInDollar || 0;
    this.regularConsultationPriceSettingInCNAM = other?.regularConsultationPriceSettingInCNAM || 0;
    this.regularConsultationPriceSettingInCNAMTP = other?.regularConsultationPriceSettingInCNAMTP || 0;
    this.doctorTierPayant = other?.doctorTierPayant || false;
    this.doctorHoliday = other?.doctorHoliday || false;
    this.secondOpinionEnabled = other?.secondOpinionEnabled || false;
    this.cliniqueId = other?.cliniqueId || undefined;
    this.duplicateAppointment = other?.duplicateAppointment || false;
    this.displayAtcd = other?.displayAtcd || null;
    this.paymentPasswordEnabled = other?.paymentPasswordEnabled || false;
    this.enableConsultationMotif = other?.enableConsultationMotif || false;
    this.enablePaymentdate = other?.enablePaymentdate || false;
    this.speechtoText = other?.speechtoText || false;
    this.enableDocuments = other?.enableDocuments || false;
    this.rdvmultiple = other?.rdvmultiple || false;
    this.secretaryPaymentsDashboard = other?.secretaryPaymentsDashboard || false;
    this.secretaryBordereau = other?.secretaryBordereau || false;
    this.chirurgieRequest = other?.chirurgieRequest || false;
    this.enabledQuestion = other?.enabledQuestion || false;
    this.psychomotorAssessment = other?.psychomotorAssessment || false;
    this.epediatricVaccinations = other?.epediatricVaccinations || EpediatricVaccinations.NOT_HAVE;
    this.enableWaitingRoom = other?.enableWaitingRoom || false;
  }

  public static fromResponse(res: any): Doctor {
    return new Doctor({
      fixPhone: res.fixPhone,
      arabicLastName: res.arabicLastName,
      arabicFirstName: res.arabicFirstName,
      arabicAddress: res.arabicAddress,
      professionalCivility: res.professionalCivility,
      arabicProfessionalCivility: res.arabicProfessionalCivility,
      professionalTitle: res.professionalTitle,
      biography: res.biography,
      arabicBiography: res.arabicBiography,
      consultationActs: res.consultationActs,
      consultationBiology: res.consultationBiology,
      consultationLaser: res.consultationLaser,
      consultationVaccinations: res.consultationVaccinations,
      consultationLens: res.consultationLens,
      consultationRadiology: res.consultationRadiology,
      consultationRefraction: res.consultationRefraction,
      prescriptionActs: res.prescriptionActs,
      prescriptionBiology: res.prescriptionBiology,
      prescriptionLaser: res.prescriptionLaser,
      prescriptionLens: res.prescriptionLens,
      prescriptionRadiology: res.prescriptionRadiology,
      prescriptionRefraction: res.prescriptionRefraction,
      speciality: Speciality.fromResponse(res.speciality || res.specialite),
      specialityDoctorName: res.specialityDoctorName,
      specialityDoctorArabicName: res.specialityDoctorArabicName,
      subSpecialities: Array.from(res.subSpecialities || [], (elm) => DoctorSubSpeciality.fromResponse(elm)),
      hasCalender: res.hasCalender,
      hasCalenderUpToDate: res.hasCalenderUpToDate,
      cnam: res.cnam,
      timeSlotLocalSetting: res.timeSlotLocalSetting == 'ATSITE' || res.timeSlotLocalSetting == 0 ? 0 : res.timeSlotLocalSetting == 'ONLINE' || res.timeSlotLocalSetting == 1 ? 1 : 2,
      printSpeciality: res.printSpeciality,
      printArabicSpeciality: res.printArabicSpeciality,
      printAddress: res.printAddress,
      printArabicAddress: res.printArabicAddress,
      printFullName: res.printFullName,
      printArabicFullName: res.printArabicFullName,
      dashboardPrintPayments: res.dashboardPrintPayments,
      patientRefSetting: res.patientRefSetting,
      regularConsultationPriceSetting: res.regularConsultationPriceSetting,
      secretaryPaymentsSetting: res.secretaryPaymentsSetting,
      secretaryAPSetting: res.secretaryAPSetting,
      consultationCNAMAP1: res.consultationCNAMAP1,
      consultationCNAMAP2: res.consultationCNAMAP2,
      consultationCNAMAP3: res.consultationCNAMAP3,
      consultationCNAMAP4: res.consultationCNAMAP4,
      appointmentTiming: res.appointmentTiming,
      pediatricVaccinations: res.pediatricVaccinations,
      smsNotification: res.smsNotification,
      smsPhone: res.smsPhone,
      teleconsultationWaitTime: res.teleconsultationWaitTime,
      qualifications: res.qualifications,
      arabicQualifications: res.arabicQualifications,
      spokenLanguages: res.spokenLanguages,
      consultationAmountTND: res.consultationAmountTND,
      consultationAmountUSD: res.consultationAmountUSD,
      consultationAmountEUR: res.consultationAmountEUR,
      packPro: res.packPro,
      packStart: res.packStart,
      duplicateAppointment: res.duplicateAppointment,
      logo: res.logo,
      cliniqueId: res?.defaultClinic?.id,
      regularConsultationPriceSettingInEuro: res?.regularConsultationPriceSettingInEuro,
      regularConsultationPriceSettingInDollar: res?.regularConsultationPriceSettingInDollar || 0,
      regularConsultationPriceSettingInCNAM: res?.regularConsultationPriceSettingInCNAM || 0,
      regularConsultationPriceSettingInCNAMTP: res?.regularConsultationPriceSettingInCNAMTP || 0,
      matriculeFiscal: res.matriculeFiscal,
      doctorTierPayant: res?.doctorTierPayant,
      doctorHoliday: res?.doctorHoliday,
      secondOpinionEnabled: res?.secondOpinionEnabled,
      displayAtcd: res?.displayAtcd,
      paymentPasswordEnabled: res?.securePayments || false,
      enableConsultationMotif: res?.enableConsultationMotif || false,
      enablePaymentdate: res?.enablePaymentdate || false,
      speechtoText: res?.speechtoText || false,
      enableDocuments: res?.enableDocuments || false,
      rdvmultiple: res?.rdvMultiple || false,
      secretaryPaymentsDashboard: res?.secretaryPaymentsDashboard || false,
      secretaryBordereau: res?.secretaryBordereau || false,
      chirurgieRequest: res?.chirurgieRequest || false,
      enabledQuestion: res?.enabledQuestion || false,
      psychomotorAssessment: res?.psychomotorAssessment || false,
      enableWaitingRoom: res?.enableWaitingRoom || false,
      epediatricVaccinations:
  EpediatricVaccinations[
    res?.epediatricVaccinations as keyof typeof EpediatricVaccinations
  ] ?? EpediatricVaccinations.NOT_HAVE, ...User.fromResponse(res),
    });
  }
}
